import Classic from './classic'

const Inputs = {
  Classic
}

export default Inputs
